// extracted by mini-css-extract-plugin
export default {"layoutRoot":"lesson-not-available_layoutRoot__2-pSU","root":"lesson-not-available_root__dsiqp","h1":"lesson-not-available_h1__JfrbW","desc":"lesson-not-available_desc__EEBBJ"};